import { render, staticRenderFns } from "./ComponentSource.vue?vue&type=template&id=00d8aee2&"
import script from "./ComponentSource.vue?vue&type=script&lang=ts&"
export * from "./ComponentSource.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports